var React = require('react');

function CloseButton (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"40","height":"40","rx":"20","fill":"#F0F1F2","key":0}),React.createElement("path",{"d":"M14.9961 13.8164L20 18.8477L25.0039 13.8438C25.25 13.5703 25.6602 13.5703 25.9336 13.8438C26.1797 14.0898 26.1797 14.5 25.9336 14.7461L20.9023 19.7773L25.9062 24.7812C26.1797 25.0273 26.1797 25.4375 25.9062 25.6836C25.6602 25.957 25.25 25.957 25.0039 25.6836L19.9727 20.6797L14.9688 25.6836C14.7227 25.957 14.3125 25.957 14.0664 25.6836C13.793 25.4375 13.793 25.0273 14.0664 24.7539L19.0703 19.75L14.0664 14.7461C13.793 14.5 13.793 14.0898 14.0664 13.8164C14.3125 13.5703 14.7227 13.5703 14.9961 13.8164Z","fill":"#232624","key":1})]);
}

CloseButton.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = CloseButton;

CloseButton.default = CloseButton;
